import { useState } from 'react'
import { useLocalizedNavigate } from '@/shared/hooks'
import { supabase } from '@/shared/lib/supabase'

interface UseSignOutReturn {
  signOut: () => Promise<void>
  isSigningOut: boolean
  error: string | null
}

export function useSignOut(): UseSignOutReturn {
  const navigate = useLocalizedNavigate()
  const [isSigningOut, setIsSigningOut] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const signOut = async () => {
    setIsSigningOut(true)
    setError(null)

    try {
      const { error: signOutError } = await supabase.auth.signOut()

      if (signOutError) {
        setError(signOutError.message)
        return
      }

      // Navigate to localized landing page (/:lang)
      navigate('/', { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unknown error')
    } finally {
      setIsSigningOut(false)
    }
  }

  return { signOut, isSigningOut, error }
}
